import ExportsLogsService from '../../services/exportsLogs'

export const state = {}

export const mutations = {}

export const getters = {}

export const actions = {
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // Inicia un export de search logs (asíncrono)
  // payload: { params: 'project=...&dateFrom=...&dateTo=...', body: { compact: true/false } }
  // eslint-disable-next-line no-unused-vars
  createSearchLogsExport(_, payload) {
    const { params, body } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createSearchLogsExport(params, body)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Inicia un export de items (asíncrono)
  // payload: { params: 'project=...', fields: ['id', 'sku', 'document', ...] }
  // eslint-disable-next-line no-unused-vars
  createItemsExport(_, payload) {
    const { params, fields } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createItemsExport(params, fields && fields.length ? { fields } : {})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Inicia un export de broadcast logs (asíncrono)
  // payload: { params: 'project=...&dateFrom=...&dateTo=...&key=...&value=...' }
  // eslint-disable-next-line no-unused-vars
  createBroadcastLogsExport(_, payload) {
    const { params } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createBroadcastLogsExport(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Inicia un export de broadcast attributions (asíncrono)
  // payload: { params: 'project=...&dateFrom=...&dateTo=...&tz=...&key=...&value=...&attributionType=...&windowType=...' }
  // eslint-disable-next-line no-unused-vars
  createBroadcastAttributionsExport(_, payload) {
    const { params } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createBroadcastAttributionsExport(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Inicia un export de reco logs (asíncrono)
  // payload: { params: 'project=...&dateFrom=...&dateTo=...&tz=...&key=...&value=...' }
  // eslint-disable-next-line no-unused-vars
  createRecoLogsExport(_, payload) {
    const { params } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createRecoLogsExport(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Inicia un export de interactions (asíncrono)
  // payload: { params: 'project=...&dateFrom=...&dateTo=...&tz=...&type=...' }
  // eslint-disable-next-line no-unused-vars
  createInteractionsExport(_, payload) {
    const { params } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createInteractionsExport(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Inicia un export de reco attributions (asíncrono)
  // payload: { params: 'project=...&dateFrom=...&dateTo=...&tz=...' }
  // eslint-disable-next-line no-unused-vars
  createRecoAttributionsExport(_, payload) {
    const { params } = payload
    return new Promise((resolve, reject) => {
      ExportsLogsService.createRecoAttributionsExport(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Lista exports de search logs para un project (y filtros opcionales)
  // eslint-disable-next-line no-unused-vars
  getSearchLogsExports(_, params) {
    return new Promise((resolve, reject) => {
      ExportsLogsService.getSearchLogsExports(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // Obtiene un export específico por ID
  // eslint-disable-next-line no-unused-vars
  getSearchLogsExportById(_, id) {
    return new Promise((resolve, reject) => {
      ExportsLogsService.getSearchLogsExportById(id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // Elimina un export específico por ID
  // eslint-disable-next-line no-unused-vars
  deleteSearchLogsExport(_, id) {
    return new Promise((resolve, reject) => {
      ExportsLogsService.deleteSearchLogsExport(id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

